export const SEROPHIN_OPERATOR = "Serophin";

export const SEROPHIN_OPERATOR_DETAILS = "ABN 88 280 015 794, PO Box 330, Annandale NSW 2038, Australia";

export const SUPPORT_EMAIL = "support@serophin.com";

export const SEROPHIN_CONTACT_URL = "https://serophin.com/contact";

export const CONTACT_APPS = [
  { id: "serophin", label: "Serophin" },
  { id: "nottldr", label: "!tldr" },
  { id: "turowl", label: "TurOwl" },
  { id: "spoola", label: "Spoola" },
  { id: "tweakpub", label: "Tweak Pub" },
  { id: "phogone", label: "PhoGone" },
  { id: "phopt", label: "Phopt" },
] as const;

export type ContactAppId = (typeof CONTACT_APPS)[number]["id"];

export const CONTACT_APP_IDS = CONTACT_APPS.map((app) => app.id) as [ContactAppId, ...ContactAppId[]];

export const contactAppLabel = (id: ContactAppId): string => CONTACT_APPS.find((app) => app.id === id)?.label ?? id;

export const isContactAppId = (value: string | null | undefined): value is ContactAppId => CONTACT_APPS.some((app) => app.id === value);

export const serophinContactUrl = (app: ContactAppId): string => `${SEROPHIN_CONTACT_URL}?app=${app}`;
